export interface User {
    userId: string;
    username: string;
}

export interface Appointment {
    startDateTime: number;
    coach: User;
    user: User;
    id: number;
    canceledAt?: string;
    isCanceled: boolean;
    canceledBy: string | null;
    isCanceled24HoursBefore: boolean | null;
    userInsuranceName?: string;
}
export interface FreeTimeSlot {
    coaches: string[];
    date: number;
}

// duplicated in booking.service.ts  api service
export const TimeSlotLength = 75;
